import React from "react";

export const EmptyCard = (props) => (
    <div className="hn-results-content">
    </div>
);